/* ===================================================================

    Author          : Valid Theme
    Template Name   : Restan - Food & Restaurant HTML Template
    Version         : 1.0

* ================================================================= */
(function($) {
    "use strict";

    $(document).ready(function() {

        /* ==================================================
            # Tooltip Init
        ===============================================*/
        $('[data-toggle="tooltip"]').tooltip();


        /* ==================================================
            # Youtube Video Init
         ===============================================*/
        $('.player').mb_YTPlayer();


        /* ==================================================
            # Scrolla active
        ===============================================*/
        $('.animate').scrolla({
            // default
            mobile: false, // disable animation on mobiles
        });


        /* ==================================================
            # imagesLoaded active
        ===============================================*/
        $('#gallery-masonary,.blog-masonry').imagesLoaded(function() {

            /* Filter menu */
            $('.mix-item-menu').on('click', 'button', function() {
                var filterValue = $(this).attr('data-filter');
                $grid.isotope({
                    filter: filterValue
                });
            });

            /* filter menu active class  */
            $('.mix-item-menu button').on('click', function(event) {
                $(this).siblings('.active').removeClass('active');
                $(this).addClass('active');
                event.preventDefault();
            });

            /* Filter active */
            var $grid = $('#gallery-masonary').isotope({
                itemSelector: '.gallery-item',
                percentPosition: true,
                masonry: {
                    columnWidth: '.gallery-item',
                }
            });

            /* Filter active */
            $('.blog-masonry').isotope({
                itemSelector: '.blog-item',
                percentPosition: true,
                masonry: {
                    columnWidth: '.blog-item',
                }
            });

        });


        /* ==================================================
            # Fun Factor Init
        ===============================================*/
        $('.timer').countTo();
        $('.fun-fact').appear(function() {
            $('.timer').countTo();
        }, {
            accY: -100
        });


        /* ==================================================
            # Magnific popup init
         ===============================================*/
        $(".popup-link").magnificPopup({
            type: 'image',
            // other options
        });

        $(".popup-gallery").magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            // other options
        });

        $(".popup-youtube, .popup-vimeo, .popup-gmaps").magnificPopup({
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });

        $('.magnific-mix-gallery').each(function() {
            var $container = $(this);
            var $imageLinks = $container.find('.item');

            var items = [];
            $imageLinks.each(function() {
                var $item = $(this);
                var type = 'image';
                if ($item.hasClass('magnific-iframe')) {
                    type = 'iframe';
                }
                var magItem = {
                    src: $item.attr('href'),
                    type: type
                };
                magItem.title = $item.data('title');
                items.push(magItem);
            });

            $imageLinks.magnificPopup({
                mainClass: 'mfp-fade',
                items: items,
                gallery: {
                    enabled: true,
                    tPrev: $(this).data('prev-text'),
                    tNext: $(this).data('next-text')
                },
                type: 'image',
                callbacks: {
                    beforeOpen: function() {
                        var index = $imageLinks.index(this.st.el);
                        if (-1 !== index) {
                            this.goTo(index);
                        }
                    }
                }
            });
        });


        /* ==================================================
            _Progressbar Init
         ===============================================*/
        function animateElements() {
            $('.progressbar').each(function() {
                var elementPos = $(this).offset().top;
                var topOfWindow = $(window).scrollTop();
                var percent = $(this).find('.circle').attr('data-percent');
                var animate = $(this).data('animate');
                if (elementPos < topOfWindow + $(window).height() - 30 && !animate) {
                    $(this).data('animate', true);
                    $(this).find('.circle').circleProgress({
                        // startAngle: -Math.PI / 2,
                        value: percent / 100,
                        size: 130,
                        thickness: 13,
                        lineCap: 'round',
                        emptyFill: '#f1f1f1',
                        fill: {
                            gradient: ['#2667FF', '#6c19ef']
                        }
                    }).on('circle-animation-progress', function(event, progress, stepValue) {
                        $(this).find('strong').text((stepValue * 100).toFixed(0) + "%");
                    }).stop();
                }
            });

        }

        animateElements();
        $(window).scroll(animateElements);

        /* ==================================================
            # Brand Carousel
         ===============================================*/
        const brandCarousel = new Swiper(".brand-style-one-carousel", {
            // Optional parameters
            loop: true,
            slidesPerView: 2,
            spaceBetween: 30,
            autoplay: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                1400: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                }
            },
        });


        /* ==================================================
            # Food Category Carousel
         ===============================================*/
        const foodCatCarousel = new Swiper(".food-cat-carousel", {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: ".food-cat-next",
                prevEl: ".food-cat-prev"
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            },
        });

        /* ==================================================
            # Testimonials Carousel
         ===============================================*/
        const testimonialCarousel = new Swiper(".testimonial-carousel", {
            // Optional parameters
            direction: "horizontal",
            loop: true,
            autoplay: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },

            // And if we need scrollbar
            /*scrollbar: {
            el: '.swiper-scrollbar',
          },*/
        });


        /* ==================================================
            # Food Menu Carousel
         ===============================================*/
        const foodMenuCarousel = new Swiper(".food-menu-carousel", {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
        });


        /* ==================================================
            # Services Style One Carousel
         ===============================================*/
        const testimonialTwo = new Swiper(".services-style-one-carousel", {
            // Optional parameters
            loop: true,
            freeMode: true,
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 50,
            autoplay: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".services-cat-next",
                prevEl: ".services-cat-prev"
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                },
            },
        });


        /* ==================================================
            # Product Gallery Carousel
         ===============================================*/
        const productGallery = new Swiper(".product-gallery-carousel", {
            // Optional parameters
            loop: true,
            slidesPerView: 2,
            spaceBetween: 30,
            autoplay: false,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                },
            },
        });


        /* ==================================================
            # Related Product Carousel
         ===============================================*/
        const relatedProduct = new Swiper(".related-product-carousel", {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
                1400: {
                    slidesPerView: 4,
                },
            },
        });


        /* ==================================================
            Date Picker Init
        ================================================== */
        $('.date-picker-one').datepicker()

        /* ==================================================


        Nice Select Init
        ===============================================*/
        $('.reservation-form select').niceSelect();


        /* ==================================================
            GSAP animation
        ================================================== */

        let animateUpDown = document.querySelector(".upDownScrol");
        if (animateUpDown) {

            gsap.set(".upDownScrol", {
                yPercent: 105
            });
            gsap.to(".upDownScrol", {
                yPercent: -105,
                ease: "none",
                scrollTrigger: {
                    trigger: ".upDownScrol",
                    end: "bottom center",
                    scrub: 1
                },
            });
        }

        /* ==================================================
       Instagram
    ===============================================*/
        $('.instagram-carousel').each(function () {
            $(this).find('.single-instagram-post')
                .on('auxclick click', function (e) {
                    e.preventDefault();
                })
                .on('middleclick', function (e) {
                    window.open($(this).attr('data-permalink'));
                });

            $(this).magnificPopup({
                type: 'image',
                delegate: 'a',
                mainClass: 'mfp-fade',
                gallery: {
                    enabled: true,
                    navigateByImgClick: false,
                },
                removalDelay: 300,
                preloader: false,
                preload: [0, 0],
                fixedContentPos: false,
                callbacks: {
                    buildControls: function() {

                        let dots = $("<div class='mfp-dots'></div>");

                        let popup = this;

                        popup._checkIfClose = function(target) {

                            if($(target).hasClass('mfp-prevent-close')) {
                                return;
                            }

                            let closeOnContent = popup.st.closeOnContentClick;
                            let closeOnBg = popup.st.closeOnBgClick;

                            if(closeOnContent && closeOnBg) {
                                return true;
                            } else {

                                // We don't close the popup if click is on navigation dots
                                if($(target).hasClass('mfp-dots') || $(target).hasClass('mfp-dot')) {
                                    return false;
                                }

                                // We close the popup if click is on close button or on preloader. Or if there is no content.
                                if(!popup.content || $(target).hasClass('mfp-close') || (popup.preloader && target === popup.preloader[0]) ) {
                                    return true;
                                }

                                // if click is outside the content
                                if(  (target !== popup.content[0] && !$.contains(popup.content[0], target))  ) {
                                    if(closeOnBg) {
                                        // last check, if the clicked element is in DOM, (in case it's removed onclick)
                                        if( $.contains(document, target) ) {
                                            return true;
                                        }
                                    }
                                } else if(closeOnContent) {
                                    return true;
                                }

                            }
                            return false;
                        };

                        let children = Object.values(popup.st.items).slice(0, popup.st.items.length);

                        children.forEach((item, index)  => {
                            dots.append("<button type='button' class='mfp-dot' aria-label='post "+index+"' data-index='"+index+"'></button>");
                        });

                        popup.contentContainer.append(dots);
                    },
                    open: function () {
                        $('body').addClass('mfp-opened mfp-carousel-opened');
                    },
                    close: function () {
                        $('body').removeClass('mfp-opened mfp-carousel-opened');
                    },
                    imageLoadComplete: function () {
                        let popup = this;
                        let currItem = popup.currItem;

                        $(currItem.img).on('click middleclick', function () {
                            window.open(currItem.el.attr('data-permalink'));
                        });

                        popup.contentContainer.append(popup.arrowLeft.add(popup.arrowRight));

                        popup.contentContainer.find(".mfp-dots .mfp-dot").removeClass('mfp-dot-active');
                        popup.contentContainer.find(".mfp-dots .mfp-dot[data-index="+currItem.index+"]").addClass('mfp-dot-active');

                        popup.contentContainer.find(".mfp-dots .mfp-dot").on('click', function () {
                            popup.goTo(Number($(this).attr('data-index')));
                            popup.updateItemHTML();
                        });
                    }
                }
            })
        });

    }); // end document ready function


    /* ==================================================
        Preloader Init
     ===============================================*/
    $(window).on('load', function() {
        setTimeout(function() {
            $('#restan-preloader').fadeOut(300).addClass('loaded');
            $("#preloader").fadeOut(300).addClass('loaded');
        }, 500)
    });

})(jQuery); // End jQuery
